var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditField = function SvgEditField(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M40.353 22.286l-5.96 14.749 1.855.75 5.959-14.75-1.854-.749zm-.183-2.218l3.709 1.499c.512.207.76.787.555 1.296L37.73 39.455a.997.997 0 0 1-1.3.547l-3.708-1.498a.997.997 0 0 1-.555-1.296l6.704-16.593a.997.997 0 0 1 1.3-.547zm-5.154 19.436l-.97-.392-.002 1.4.972-1.008zm-2.975 3.485l.007-5.358a.995.995 0 0 1 1.372-.916l3.709 1.498a.995.995 0 0 1 .35 1.612l-3.717 3.86c-.623.647-1.723.203-1.721-.696zm.93-.977c.552 0 1 .445 1 .994 0 .549-.448.994-1 .994h-18.4c-.552 0-1-.445-1-.994 0-.55.448-.994 1-.994h18.4z"
  })));
};
export default SvgEditField;